import {
  action,
  computed,
  makeObservable,
  observable,
  onBecomeObserved,
  toJS,
} from "mobx"
import { PaginationProps } from "antd"

export type CollectionStateType<T> = {
  items: T[]
}

class Collection<T> {
  state: CollectionStateType<T> = {
    items: [],
  }

  constructor(args: T[] = []) {
    makeObservable(this, {
      append: action.bound,
      getByKey: action.bound,
      removeByKey: action.bound,
      state: observable.deep,
    })

    if (args.length > 0) {
      this.replace(args)
    }
  }

  append(...items: T[]) {
    this.state.items = [...this.state.items, ...items]
  }

  find(cb: (...args: [T, number, T[]]) => boolean) {
    return this.state.items.find(cb)
  }

  getByKey(data: Partial<Record<keyof T, any>>) {
    const dataEntries = Object.entries(data) as [keyof T, unknown][]

    return this.items.find((i) => {
      return dataEntries.some(([key, value]) => i[key] === value)
    })
  }

  removeByKey(data: Partial<Record<keyof T, any>>) {
    const dataEntries = Object.entries(data) as [keyof T, unknown][]

    this.replace(
      this.items.filter((i) => {
        return dataEntries.some(([key, value]) => i[key] !== value)
      }),
    )
  }

  replace(items: T[] = []) {
    this.state.items = [...items]
  }

  get isEmpty() {
    return this.items.length === 0
  }

  get items(): T[] {
    return this.state.items
  }

  get itemsToJS() {
    return toJS(this.items) as T[]
  }
}

export default Collection
